var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"upload",staticStyle:{"display":"none"},attrs:{"type":"file","multiple":false},on:{"change":_vm.onChange}}),_c('a-button',{attrs:{"loading":_vm.loading},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.type === 'not-sign' ? '已中标未签订合同导入' : '其他合同导入'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }